import { useSettings } from "@/context/SettingsContext";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Phone, Mail, MapPin, Clock, Instagram, Truck } from "lucide-react";

export default function Contact() {
  const { settings } = useSettings();
  const rows = [
    { icon: Phone, label: "Phone", value: settings.phone },
    { icon: Mail, label: "Email", value: settings.email },
    { icon: MapPin, label: "Address", value: settings.address },
    { icon: Clock, label: "Timings", value: settings.timings },
    { icon: Truck, label: "Delivery", value: settings.delivery_info },
  ].filter((r) => r.value);

  return (
    <div className="animate-fade-in">
      <div className="bg-brand-gold-light/40 py-14">
        <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
          <p className="text-sm uppercase tracking-[0.2em] text-brand-gold">Get in touch</p>
          <h1 className="mt-2 font-heading text-4xl text-brand-dark sm:text-5xl">Contact Us</h1>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-brand-line bg-white p-8">
          <div className="space-y-5">
            {rows.map((r) => (
              <div key={r.label} className="flex items-start gap-4" data-testid={`contact-${r.label.toLowerCase()}`}>
                <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand">
                  <r.icon className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-widest text-brand-muted">{r.label}</p>
                  <p className="text-brand-dark">{r.value}</p>
                </div>
              </div>
            ))}
            {settings.instagram && (
              <div className="flex items-start gap-4">
                <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-brand/10 text-brand">
                  <Instagram className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-widest text-brand-muted">Instagram</p>
                  <a href={settings.instagram} target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">
                    {settings.instagram}
                  </a>
                </div>
              </div>
            )}
          </div>

          <div className="mt-8 border-t border-brand-line pt-6 text-center">
            <p className="mb-4 text-brand-muted">Quickest way to reach us:</p>
            <WhatsAppButton testId="contact-whatsapp-btn" message={`Hi ${settings.business_name || "Taanya Homefoods"}, I have a question.`} />
          </div>
        </div>
      </div>
    </div>
  );
}
